import styled from 'styled-components';
import variables from '../../../_metronic/variables.scss';

export const Container = styled.button`
 display: flex;
 height: 64px;
 max-width: 384px;
 width: 100%;
 background-color: ${variables.detailColorLight2};
 border: 0;
 color: ${variables.colorTextLight};
 border-radius: 12px;
 font-size: 18px;
 font-weight: 600;
 align-items: center;
 justify-content: center;
 margin-bottom: ${({marginBottom}) => marginBottom ? marginBottom : 0};
 margin: 32px auto 0;
 font-family: 'Biennale SemiBold';

 svg {
	transform: rotate(90deg);
 }

 :hover {
   transition: ${({isLoading}) => isLoading ? 0 :  '0.3s'};
   opacity: ${({isLoading}) => isLoading ? 1 :  '0.8'};
   border: 1px solid ${props => props.theme.colors.primary};
   border: ${({isLoading}) => isLoading && 0};
   color: ${({isLoading}) => isLoading ? props => props.theme.colors.ligth : props => props.theme.colors.primary};
   background: ${({isLoading}) => isLoading ? props => props.theme.colors.primary :  'transparent'};
 }

 @media(max-width: 768px){
   height: 56px;
   margin: 24px auto 0;
   font-size: 16px;
 }
`;
